/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
  Paper,
  Grid,
  Stack,
  styled,
  MenuItem,
  Chip,
  Autocomplete,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Accordion,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Box,
} from '@mui/material';
import moment from 'moment';
import { saveAs } from 'file-saver';
import numeral from 'numeral';
import { useTheme } from '@emotion/react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Email, Phone, LocationOn } from '@mui/icons-material';
import PortraitIcon from '@mui/icons-material/Portrait';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import VerifiedIcon from '@mui/icons-material/Verified';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import PreviewIcon from '@mui/icons-material/Preview';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import PreviewForCourierOrderApproval from '../Admin/PreviewForCourierOrderApproval';
import PreviewForCargoOrderApproval from '../Admin/PreviewForCargoOrderApproval';
import AddBookingForCourierAndCargoOrderCreation from './AddBookingForCourierAndCargoOrderCreation';
import NoResultsFound from '../../../components/NoResultsFound';
import ComplaintAdd from '../Common/ComplaintAdd';

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#257180',
  },
  whiteSpace: 'nowrap',
});

const StyledTableCell2 = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#8EB486',
  },
  whiteSpace: 'nowrap',
});

const approvalStatusOptions = [
  { label: 'All', value: 'All' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Cancelled Request', value: 'Cancelled Request' },
  { label: 'Booking Confirmed', value: 'Booking Confirmed' },
  { label: 'Bill Raised', value: 'Bill Raised' },
  { label: 'Payment Received', value: 'Payment Received' },
  { label: 'Part. Payment', value: 'Part. Payment' },
];

const customizedItemsOptions = [
  { label: 'All', value: 'All' },
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' },
];

const outstandingOptions = [
  { label: 'All', value: 'All' },
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

const typeOptionsIN = [{ label: 'Air-Cargo', value: 'courier' }];

const typeOptionsUK = [
  { label: 'All', value: 'All' },
  { label: 'Air-Cargo', value: 'courier' },
  { label: 'Sea-Cargo', value: 'cargo' },
];

const typeOptionsSL = [{ label: 'Air-Cargo', value: 'courier' }];

const statusTypeOptions = [
  { label: 'All', value: 'All' },
  { label: 'Order Status', value: 'Order' },
  { label: 'Bill Status', value: 'Bill' },
  { label: 'Reciept Status', value: 'Receipt' },
];

const statusOptions = [
  { label: 'All', value: 'All' },
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

const searchByOptions = [
  { label: 'Phone Number', value: 'phonenumber' },
  { label: 'Ledger', value: 'ledger' },
  { label: 'Email ID', value: 'emailid' },
];

const complaintStatusOptions = [
  { label: 'All', value: 'All' },
  { label: 'Complaint Received', value: 'Yes' },
  { label: 'Complaint Not Received', value: 'No' },
];

const OrderFollwUps = () => {
  const origin = sessionStorage.getItem('Origin') || 'IN'; // Default to IN if not set
  const theme = useTheme();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));
  // snackbar context
  const { openSnackBar, closeSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [expanded, setExpanded] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [ledgerPhoneFilterData, setLedgerPhoneFilterData] = useState([]);
  const [salesExecutiveFilterData, setSalesExecutiveFilterData] = useState([]);
  const [withoutuser, setWithoutuser] = useState(false);
  // pagination
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = tableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    return { totalRows, currentPage };
  }, [tableData, page, rowsPerPage]);
  const [companyId, setCompanyId] = useState(sessionStorage.getItem('CompanyId'));
  const [isDialogOpen, setDialogOpenState] = useState(false);
  const [isAddDialogOpen, setAddDialogOpenState] = useState(false);
  const [currentOrderDetails, setCurrentOrderDetails] = useState(null);
  const [branchList, setBranchList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [filterInputs, setFilterInputs] = useState({
    ledger: null,
    fromDate: moment().startOf('month').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    approvalStatus: 'All',
    type: 'courier',
    phonenumber: '',
    salesExecutive: '',
    customizedItems: 'All',
    statusType: 'All',
    status: 'All',
    outstanding: 'All',
    droppedOrder: 'N',
    searchBy: 'phonenumber',
    Branch: '',
    senderCountry: '',
    receiverCountry: '',
    complaintStatus: 'All',
  });
  const [ledgerInputValue, setLedgerInputValue] = useState('');
  const [isComplaintDialogOpen, setComplaintDialogOpenState] = useState(false);
  const [viewDraft, setViewDraft] = useState(false);
  const [complaintDetail, setComplaintDetail] = useState({
    courierCargoId: '',
    shipmentType: '',
    userType: 'SE',
    complaintId: '',
    bookingOrderId: 0,
    Register: 'N',
  });

  const getOriginCountryId = (countries = []) => {
    const origin = (sessionStorage.getItem('Origin') || '').toUpperCase();
    const match = countries.find((country) => {
      const countryName = (country.CountryName || '').trim().toUpperCase();
      const countryCode = (country.CountryCode || '').trim();

      if (origin === 'IN') {
        return countryName === 'INDIA' || Number(country.CountryId) === 25 || countryCode === '8025';
      }
      if (origin === 'SL') {
        return (
          countryName === 'SRI LANKA' ||
          countryName === 'SRILANKA' ||
          Number(country.CountryId) === 24 ||
          countryCode === '8024'
        );
      }
      if (origin === 'UK') {
        return (
          countryName === 'UK' ||
          countryName === 'UNITED KINGDOM' ||
          Number(country.CountryId) === 232 ||
          countryCode === '8232'
        );
      }
      return false;
    });

    return match ? String(match.CountryId) : '';
  };

  const closeComplaintDialog = () => {
    setComplaintDialogOpenState(false);
  };

  const openComplaintDialog = (data) => {
    setComplaintDetail((prev) => ({
      ...prev,
      courierCargoId: data.orderid,
      shipmentType: data.shipment_Type,
      complaintId: data.complaintId,
      bookingOrderId: data.BookOrderId,
      Register: data.Register,
    }));
    setComplaintDialogOpenState(true);
  };

  const GetAllHelpData = async (withoutuserFilter = false) => {
    try {
      showLoading();
      const userID = withoutuserFilter ? 0 : sessionStorage.getItem('UserId');
      const [ledgerResponse, salesExecutiveResponse] = await Promise.all([
        // axios.get('/master/customer/GetCustomerHelp/4'),
        axios.get(`/Transactions/SalesControls/GetCustomerHelpForSE/${companyId}/${userID}/0`),
        axios.get(`/Approval/LoginApprovalRoute/GetAllAssignedSalesExecutive/${sessionStorage.getItem('UserId')}`),
      ]);
      setLedgerPhoneFilterData(ledgerResponse.data);
      setSalesExecutiveFilterData(salesExecutiveResponse.data);
    } catch (e) {
      openSnackBar('Something Went Wrong', 'error');
    }
    hideLoading();
  };

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');
      const countries = res.data || [];
      setCountryList(countries);
      const originCountryId = getOriginCountryId(countries);
      const originCountry = countries.find((country) => String(country.CountryId) === originCountryId);
      if (originCountry) {
        setFilterInputs((prev) => ({ ...prev, senderCountry: originCountry }));
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      // const response = await axios.post('signup/GetBranchList', requestData, config);
      const response = await axios.post(
        'Approval/LoginApprovalRoute/GetBranchLog',
        {
          UserId: sessionStorage.getItem('UserId'),
        },
        config
      );
      const data = response.data.filter((i) => i.webBranch === 'Y');
      setBranchList(data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  useEffect(() => {
    GetAllHelpData();
    GetBranchList(sessionStorage.getItem('Origin'));
    GetCountryList();
  }, []);

  const handleFilterInputs = (e) => {
    setFilterInputs({
      ...filterInputs,
      [e.target.name]: e.target.value,
    });
  };

  const handleReviewButtonClick = (order) => {
    setCurrentOrderDetails(order);
    setDialogOpenState(true);
    console.log(order, 'order');
  };

  const handleAddButtonClick = () => {
    setAddDialogOpenState(true);
  };

  const closeDialog = () => {
    setDialogOpenState(false);
    setCurrentOrderDetails(null);
  };

  const closeAddDialog = () => {
    setAddDialogOpenState(false);
  };

  async function getAllData() {
    if (!validateFilters()) {
      return; // If validation fails, stop the request
    }
    try {
      showLoading();
      let sumData = [];
      if (filterInputs.type !== 'All') {
        const response = await axios.post(`/Transactions/${filterInputs.type}/GetAllSEOrder`, {
          ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
          fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
          toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
          salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
          approvalStatus: filterInputs.approvalStatus,
          customizedItem: filterInputs.customizedItems,
          status: filterInputs.status,
          statusType: filterInputs.statusType,
          outStanding: filterInputs.outstanding,
          BranchId: filterInputs.Branch?.BranchId || 0,
          defaultSalesExecutiveId: withoutuser ? 0 : sessionStorage.getItem('UserId'),
          senderCountry: filterInputs.senderCountry?.CountryId || 0,
          receiverCountry: filterInputs.receiverCountry?.CountryId || 0,
          complaintStatus: filterInputs.complaintStatus,
          viewdraft: viewDraft ? 'Y' : 'N',
        });
        if (tableData.length === 0 && response.data.length !== 0) setExpanded(false);
        setTableData(response.data);
        sumData = response.data;
      } else {
        const [response1, response2] = await Promise.all([
          axios.post(`/Transactions/Courier/GetAllSEOrder`, {
            ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
            fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
            toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
            salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
            approvalStatus: filterInputs.approvalStatus,
            customizedItem: filterInputs.customizedItems,
            status: filterInputs.status,
            statusType: filterInputs.statusType,
            outStanding: filterInputs.outstanding,
            BranchId: filterInputs.Branch?.BranchId || 0,
            defaultSalesExecutiveId: withoutuser ? 0 : sessionStorage.getItem('UserId'),
            senderCountry: filterInputs.senderCountry?.CountryId || 0,
            receiverCountry: filterInputs.receiverCountry?.CountryId || 0,
            complaintStatus: filterInputs.complaintStatus,
            viewdraft: viewDraft ? 'Y' : 'N',
          }),
          axios.post(`/Transactions/Cargo/GetAllSEOrder`, {
            ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
            fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
            toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
            salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
            approvalStatus: filterInputs.approvalStatus,
            customizedItem: filterInputs.customizedItems,
            status: filterInputs.status,
            statusType: filterInputs.statusType,
            outStanding: filterInputs.outstanding,
            BranchId: filterInputs.Branch?.BranchId || 0,
            defaultSalesExecutiveId: withoutuser ? 0 : sessionStorage.getItem('UserId'),
            senderCountry: filterInputs.senderCountry?.CountryId || 0,
            receiverCountry: filterInputs.receiverCountry?.CountryId || 0,
            complaintStatus: filterInputs.complaintStatus,
            viewdraft: viewDraft ? 'Y' : 'N',
          }),
        ]);

        const data = [...response1.data, ...response2.data].sort((a, b) => b.orderDate.localeCompare(a.orderDate));
        if (tableData.length === 0 && data.length !== 0) setExpanded(false);
        setTableData(data);
        sumData = data;
      }
      const summaryData = {
        noOfOrders: sumData.length,
        airCargo: sumData.filter((item) => item.shipmentType === 'Courier').length,
        seaCargo: sumData.filter((item) => item.shipmentType === 'Cargo').length,
        parcelWeight: parseFloat(
          sumData.reduce((sum, item) => sum + (parseFloat(item.gross_weight) || 0), 0).toFixed(2)
        ),
        noOfBoxes: sumData.reduce((sum, item) => sum + (Number(item.NO_OF_BOXES) || 0), 0),
      };

      // Map summary data to existing `dataList` format
      const updatedDataList = [
        { title: 'No. of Orders', value: summaryData.noOfOrders, bgColor: '#e0f7fa', textColor: '#006064' },
        { title: 'Air Cargo', value: summaryData.airCargo, bgColor: '#ffe0b2', textColor: '#e65100' },
        { title: 'Sea Cargo', value: summaryData.seaCargo, bgColor: '#e1bee7', textColor: '#6a1b9a' },
        { title: 'Parcel Weight', value: `${summaryData.parcelWeight}kg`, bgColor: '#c8e6c9', textColor: '#1b5e20' },
        { title: 'No. of Boxes', value: summaryData.noOfBoxes, bgColor: '#ffccbc', textColor: '#bf360c' },
      ];

      // Update `datalist` state
      setDataList(updatedDataList);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  const GetOrderFollowupExcel = async () => {
    showLoading();
    try {
      const response = await axios.post(
        '/Transactions/ExcelRoute/SalesOrderFollowupExcel',
        {
          type: filterInputs.type,
          ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
          fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
          toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
          salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
          salesExecutiveName: filterInputs.salesExecutive?.salesPersonName || '',
          approvalStatus: filterInputs.approvalStatus,
          customizedItem: filterInputs.customizedItems,
          status: filterInputs.status,
          statusType: filterInputs.statusType,
          outStanding: filterInputs.outstanding,
          searchby: filterInputs.searchBy,
          ledger: filterInputs.ledger?.CUSTOMERNAME || '',
          phonenumber: filterInputs.ledger?.Phone || '',
          emailId: filterInputs.ledger?.EmailId || filterInputs.ledger?.emailId || filterInputs.ledger?.EMAILID || '',
          BranchName: filterInputs.Branch?.BranchName || '',
          BranchId: filterInputs.Branch?.BranchId || 0,
          defaultSalesExecutiveId: sessionStorage.getItem('UserId') || 0,
          senderCountry: filterInputs.senderCountry?.CountryId || 0,
          receiverCountry: filterInputs.receiverCountry?.CountryId || 0,
          senderCountryName: filterInputs.senderCountry?.CountryName || 0,
          receiverCountryName: filterInputs.receiverCountry?.CountryName || 0,
          complaintStatus: filterInputs.complaintStatus,
          viewdraft: viewDraft ? 'Y' : 'N',
        },
        { responseType: 'blob' }
      );
      const excelBlob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      saveAs(excelBlob, `Booking Followup Panel-${moment(new Date()).format('MMMM Do YYYY, h-mm a')}`);
      setTimeout(() => {
        hideLoading();
      }, 2000);
    } catch (error) {
      if (error.response?.status === 404) {
        openSnackBar('No records found to export.', 'error');
      } else {
        openSnackBar('Something went wrong! Try again.', 'error');
      }
      hideLoading();
    }
  };

  const [oneCustomerFollowUps, setOneCustomerFollowUps] = useState([]);

  // popup controls
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  // State to manage new follow-up details
  const [newFollowUp, setNewFollowUp] = useState({
    customerId: null,
    createdDateTime: null,
    followUpDateTime: '',
    remarks: '',
    action: '',
  });
  const [fieldErrors, setFieldErrors] = useState({ followUpDateTime: false });
  const [isEditing, setIsEditing] = useState(false);
  const [editingRowId, setEditingRowId] = useState(null);
  const [rowDeleteID, setRowDeleteID] = useState(null);
  const [openOrderDeleteDialog, setOpenOrderDeleteDialog] = useState(false);
  const [orderDeleteData, setOrderDeleteData] = useState(null); // { id, type }
  const [openFollowUpTable, setOpenFollowUpTable] = useState(null);
  const [rowData, SetRowData] = useState(null);

  // Handle follow-up change for remarks
  const handleFollowUpChange = (e) => {
    setNewFollowUp({ ...newFollowUp, remarks: e.target.value });
  };

  const handleFollowUpDateTimeChange = (e) => {
    // Simply use the input value as is, no need to adjust time zones
    const newDate = e.target.value;

    setNewFollowUp({ ...newFollowUp, followUpDateTime: newDate });

    // Validate if the selected date and time is in the future
    const currentDate = new Date();
    const selectedDate = new Date(newDate);
    const isValidDate = selectedDate >= currentDate;

    setFieldErrors((prevFieldErrors) => ({
      ...prevFieldErrors,
      followUpDateTime: !isValidDate,
    }));
  };

  async function InsertCustomerTimeLine() {
    const localDate = new Date(newFollowUp.followUpDateTime);
    const utcDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
    const followupDateUTC = utcDate.toISOString(); // Convert to "YYYY-MM-DDTHH:mm:ss.sssZ"
    if (isEditing) {
      const newData = {
        Optype: 'Edit',
        followupDate: new Date(newFollowUp.followUpDateTime).toLocaleString(),
        remarks: newFollowUp.remarks,
        modifiedBy: sessionStorage.getItem('UserId'),
        modifiedOn: new Date(),
        timelineId: editingRowId,
      };
      try {
        showLoading();
        const response = await axios.post('Transactions/Customer_Timeline/InsertCustomerTimeline', newData);
        if (response.status === 200) {
          // openSnackBar('Customer Timeline Updated Successfully!', 'success');
        }
      } catch (e) {
        openSnackBar('Something Went Wrong try Again !', 'error');
      }
      hideLoading();
    } else {
      const newData = {
        Optype: 'New',
        customerId: rowData.customerId,
        companyId: sessionStorage.getItem('CompanyId'),
        branchId: 0,
        Order_ID: rowData.orderid,
        Order_Type: rowData.shipmentType === 'Courier' ? 'CO' : 'CA',
        remarks: newFollowUp.remarks,
        followup: 'Follow Up',
        // followupDate: new Date(newFollowUp.followUpDateTime).toLocaleString(),
        followupDate: followupDateUTC,
        createdBy: sessionStorage.getItem('UserId'),
        createdOn: new Date().toISOString(),
      };
      try {
        showLoading();
        const response = await axios.post('Transactions/Customer_Timeline/InsertCustomerTimeline', newData);
        if (response.status === 200) {
          // openSnackBar('Customer Timeline Created Successfully!', 'success');
        }
      } catch (e) {
        openSnackBar('Something Went Wrong try Again !', 'error');
      }
      hideLoading();
    }
    setOpenDialog(false);
    GetOneBookingTimeLine(rowData);
    resetFollowUpState();
  }

  const handleDeleteFollowUp = async () => {
    showLoading();
    try {
      const response = await axios.delete(`Transactions/Customer_Timeline/DeleteCustomerTimeline/${rowDeleteID}`);
      if (response.status === 200) {
        openSnackBar('Record Deleted successfully !', 'error');
      }
      hideLoading();
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
      hideLoading();
    }
    GetOneBookingTimeLine(rowData);
    setRowDeleteID(null);
  };

  // Handle Edit Button Click
  const handleEditFollowUp = (editData) => {
    if (editData) {
      const formattedDate = moment.utc(editData.followupDate).local().format('YYYY-MM-DDTHH:mm');

      // Set the form fields with the formatted date and other values
      setNewFollowUp({
        followUpDateTime: formattedDate, // Set the formatted date for the edit
        remarks: editData.remarks,
      });
      setEditingRowId(editData.timelineId);
      setIsEditing(true);
      setOpenDialog(true);
    }
  };

  const handleFollowUpTableToggle = (rowIndex, data) => {
    SetRowData(data);
    GetOneBookingTimeLine(data);
    setOpenFollowUpTable(true);
  };

  const handleOpenConfirmDialog = (boxIndex) => {
    setRowDeleteID(boxIndex); // Set the box to be deleted
    setOpenConfirmDialog(true); // Open the confirmation dialog
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setRowDeleteID(null);
    resetFollowUpState();
  };

  const handleConfirmDelete = () => {
    if (rowDeleteID !== null) {
      handleDeleteFollowUp(rowDeleteID); // Call the delete function
    }
    handleCloseConfirmDialog(); // Close the confirmation dialog
  };

  async function GetOneBookingTimeLine(rowData) {
    try {
      showLoading();
      // const response = await axios.get(
      //   `/Transactions/Customer_Timeline/GetOneBookingTimeLine/${rowData.orderNo}/${sessionStorage.getItem(
      //     'BranchId'
      //   )}/${sessionStorage.getItem('UserId')}/${moment(rowData.ExpiryDate).format('YYYYMMDD')}/${rowData.Type}`
      // );
      // const response = await axios.get(
      //   `/Transactions/Customer_Timeline/GetOneBookingTimeLine/${rowData.orderid}/0/${sessionStorage.getItem(
      //     'UserId'
      //   )}/${rowData.ExpiryDate}/${rowData.shipmentType === 'Courier' ? 'CO' : 'CA'}`
      // );
      const response = await axios.post(`/Transactions/Customer_Timeline/GetOneBookingTimeLine`, {
        Order_ID: rowData.orderid,
        branchId: 0,
        userId: sessionStorage.getItem('UserId'),
        ExpiryDate: rowData.ExpiryDate,
        OrderType: rowData.shipmentType === 'Courier' ? 'CO' : 'CA',
      });
      setOneCustomerFollowUps(response.data);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  // Reset Follow-up State
  const resetFollowUpState = () => {
    setNewFollowUp({
      followUpDateTime: '',
      remarks: '',
      action: '',
    });
    setIsEditing(false);
    setEditingRowId(null);
    setRowDeleteID(null);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    resetFollowUpState();
  };

  const [formErrors, setFormErrors] = useState({
    fromDate: '',
    toDate: '',
  });

  const reopenSnackBar = (message, severity) => {
    closeSnackBar();
    setTimeout(() => {
      openSnackBar(message, severity);
    }, 100);
  };

  const validateFilters = () => {
    const errors = {};
    // Validate fromDate: should not be empty
    if (!filterInputs.fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(filterInputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate: should not be empty and be a valid date
    if (!filterInputs.toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(filterInputs.toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);

    // When checkbox is checked, a valid customer lookup selection is mandatory
    if (withoutuser && !ledgerInputValue.trim() && !filterInputs.ledger) {
      reopenSnackBar('Please select a search by Customer Name, Phone Number or Email ID', 'warning');
      return false;
    }

    if (withoutuser && ledgerInputValue.trim() && !filterInputs.ledger) {
      reopenSnackBar('Please select a record from the dropdown list', 'warning');
      return false;
    }

    return Object.keys(errors).length === 0; // Return true if no errors
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#8EACCD',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Order Approval & follow-ups
            </Typography>
          </Typography>
        </Grid>
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={() => {
              setExpanded((expand) => !expand);
            }}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                  <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#8EACCD',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
                {/* <Grid item xs={12} sx={{ textAlign: 'end', pt: 0 }}>
                  <FormControlLabel
                    sx={{
                      flexShrink: 0,
                      '& .MuiFormControlLabel-label': { fontSize: '14px' }, // adjust font size as needed
                    }}
                    control={
                      <Checkbox
                        size="small"
                        name="droppedOrder"
                        checked={filterInputs.droppedOrder === 'Y'}
                        onChange={(event) => {
                          const value = event.target.checked ? 'Y' : 'N';
                          setFilterInputs({ ...filterInputs, droppedOrder: value });
                        }}
                        color="primary"
                      />
                    }
                    label="Cancellled Order"
                  />
                </Grid> */}

                <Grid item md={1} xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <div className="checkbox-wrapper-33">
                    <label className="checkbox" htmlFor="order-followup-check-33">
                      <input
                        id="order-followup-check-33"
                        className="checkbox__trigger visuallyhidden"
                        type="checkbox"
                        checked={withoutuser}
                        onChange={() => {
                          const nextWithoutUser = !withoutuser;
                          setWithoutuser(nextWithoutUser);
                          setLedgerInputValue('');
                          setFilterInputs({
                            ...filterInputs,
                            ledger: null,
                          });
                          setTableData([]);
                          GetAllHelpData(nextWithoutUser);
                        }}
                      />
                      <span className="checkbox__symbol">
                        <svg
                          aria-hidden="true"
                          className="icon-checkbox"
                          width="28px"
                          height="28px"
                          viewBox="0 0 28 28"
                          version="1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M4 14l8 7L24 7" />
                        </svg>
                      </span>
                    </label>
                  </div>

                  <style>{`
                    .checkbox-wrapper-33 {
                      --s-xsmall: 0.625em;
                      --s-small: 1.2em;
                      --border-width: 1px;
                      --c-primary: #5F11E8;
                      --c-primary-20-percent-opacity: rgb(95 17 232 / 20%);
                      --c-primary-10-percent-opacity: rgb(95 17 232 / 10%);
                      --t-base: 0.4s;
                      --t-fast: 0.2s;
                      --e-in: ease-in;
                      --e-out: cubic-bezier(.11,.29,.18,.98);
                    }

                    .checkbox-wrapper-33 .visuallyhidden {
                      border: 0;
                      clip: rect(0 0 0 0);
                      height: 1px;
                      margin: -1px;
                      overflow: hidden;
                      padding: 0;
                      position: absolute;
                      width: 1px;
                    }

                    .checkbox-wrapper-33 .checkbox {
                      display: flex;
                      align-items: center;
                      justify-content: flex-start;
                      cursor: pointer;
                    }

                    .checkbox-wrapper-33 .checkbox + .checkbox {
                      margin-top: var(--s-small);
                    }

                    .checkbox-wrapper-33 .checkbox__symbol {
                      display: inline-block;
                      display: flex;
                      border: var(--border-width) solid var(--c-primary);
                      position: relative;
                      border-radius: 0.1em;
                      width: 1.5em;
                      height: 1.5em;
                      transition: box-shadow var(--t-base) var(--e-out), background-color var(--t-base);
                      box-shadow: 0 0 0 0 var(--c-primary-10-percent-opacity);
                    }

                    .checkbox-wrapper-33 .checkbox__symbol:after {
                      content: "";
                      position: absolute;
                      top: 0.5em;
                      left: 0.5em;
                      width: 0.25em;
                      height: 0.25em;
                      background-color: var(--c-primary-20-percent-opacity);
                      opacity: 0;
                      border-radius: 3em;
                      transform: scale(1);
                      transform-origin: 50% 50%;
                    }

                    .checkbox-wrapper-33 .checkbox .icon-checkbox {
                      width: 1em;
                      height: 1em;
                      margin: auto;
                      fill: none;
                      stroke-width: 3;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                      stroke-miterlimit: 10;
                      color: var(--c-primary);
                      display: inline-block;
                    }

                    .checkbox-wrapper-33 .checkbox .icon-checkbox path {
                      transition: stroke-dashoffset var(--t-fast) var(--e-in);
                      stroke-dasharray: 30px, 31px;
                      stroke-dashoffset: 31px;
                    }

                    .checkbox-wrapper-33 .checkbox__trigger:checked + .checkbox__symbol:after {
                      -webkit-animation: ripple-33 1.5s var(--e-out);
                      animation: ripple-33 1.5s var(--e-out);
                    }

                    .checkbox-wrapper-33 .checkbox__trigger:checked + .checkbox__symbol .icon-checkbox path {
                      transition: stroke-dashoffset var(--t-base) var(--e-out);
                      stroke-dashoffset: 0px;
                    }

                    .checkbox-wrapper-33 .checkbox__trigger:focus + .checkbox__symbol {
                      box-shadow: 0 0 0 0.25em var(--c-primary-20-percent-opacity);
                    }

                    @-webkit-keyframes ripple-33 {
                      from {
                        transform: scale(0);
                        opacity: 1;
                      }

                      to {
                        opacity: 0;
                        transform: scale(20);
                      }
                    }

                    @keyframes ripple-33 {
                      from {
                        transform: scale(0);
                        opacity: 1;
                      }

                      to {
                        opacity: 0;
                        transform: scale(20);
                      }
                    }
                  `}</style>
                </Grid>

                <Grid item md={2} xs={12}>
                  {/* Status Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Search by"
                    name="searchBy"
                    value={filterInputs.searchBy}
                    onChange={(e) => {
                      setLedgerInputValue('');
                      setFilterInputs({
                        ...filterInputs,
                        ledger: null,
                        searchBy: e.target.value,
                      });
                    }}
                    variant="outlined"
                    size="small"
                  >
                    {searchByOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item md={3} xs={12}>
                  <Autocomplete
                    key={filterInputs.searchBy}
                    options={ledgerPhoneFilterData}
                    getOptionLabel={(customer) => {
                      if (!customer) return '';
                      if (filterInputs.searchBy === 'phonenumber') return customer.Phone || '';
                      if (filterInputs.searchBy === 'emailid')
                        return customer.EmailId || customer.emailId || customer.EMAILID || '';
                      return customer.CUSTOMERNAME || '';
                    }}
                    renderOption={(props, customer) => (
                      <li {...props} key={customer.CUSTOMERID}>
                        {filterInputs.searchBy === 'phonenumber'
                          ? customer.Phone || ''
                          : filterInputs.searchBy === 'emailid'
                            ? customer.EmailId || customer.emailId || customer.EMAILID || ''
                            : customer.CUSTOMERNAME || ''}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) => option.CUSTOMERID === value?.CUSTOMERID}
                    value={filterInputs.ledger || null}
                    inputValue={ledgerInputValue}
                    name="ledger"
                    onInputChange={(event, value, reason) => {
                      setLedgerInputValue(value);
                      if (reason === 'input' || reason === 'clear') {
                        setFilterInputs((prev) => ({
                          ...prev,
                          ledger: null,
                        }));
                      }
                    }}
                    onChange={(event, value) => {
                      const selectedValue = value
                        ? filterInputs.searchBy === 'phonenumber'
                          ? value.Phone || ''
                          : filterInputs.searchBy === 'emailid'
                            ? value.EmailId || value.emailId || value.EMAILID || ''
                            : value.CUSTOMERNAME || ''
                        : '';

                      setLedgerInputValue(selectedValue);
                      setFilterInputs({
                        ...filterInputs,
                        ledger: value,
                      });
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          filterInputs.searchBy === 'phonenumber'
                            ? 'Phone Number'
                            : filterInputs.searchBy === 'emailid'
                              ? 'Email ID'
                              : 'Ledger'
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* From Date */}
                  <TextField
                    fullWidth
                    label="From Date"
                    type="date"
                    name="fromDate"
                    value={filterInputs.fromDate}
                    onChange={handleFilterInputs}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    error={!!formErrors.fromDate}
                    helperText={formErrors.fromDate}
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* To Date */}
                  <TextField
                    fullWidth
                    label="To Date"
                    type="date"
                    name="toDate"
                    value={filterInputs.toDate}
                    onChange={handleFilterInputs}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    inputProps={{ max: '9999-12-31' }}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* Shipment Type Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Shipment Type"
                    name="type"
                    value={filterInputs.type}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {(sessionStorage.getItem('Origin') === 'IN'
                      ? typeOptionsIN
                      : sessionStorage.getItem('Origin') === 'UK'
                      ? typeOptionsUK
                      : typeOptionsSL
                    ).map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={3} xs={12}>
                  {/* Branch */}
                  <Autocomplete
                    options={branchList} // Use branchList as options
                    getOptionLabel={(branch) => branch.BranchName} // Display branch names
                    renderOption={(props, branch) => (
                      <li {...props} key={branch.BranchId}>
                        {branch.BranchName}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) => option.BranchId === value?.BranchId}
                    value={filterInputs.Branch || null} // Select branch from filterInputs
                    name="Branch"
                    onChange={(event, value) => {
                      setFilterInputs({ ...filterInputs, Branch: value });
                    }}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Branch" variant="outlined" />}
                  />
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* Customized item Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Customized Items"
                    name="customizedItems"
                    value={filterInputs.customizedItems}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {customizedItemsOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={1} xs={12}>
                  {/* OutStanding Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Outstanding"
                    name="outstanding"
                    value={filterInputs.outstanding}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {outstandingOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={2} xs={12}>
                  {/* Status Type Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Status Type"
                    name="statusType"
                    value={filterInputs.statusType}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {statusTypeOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={1} xs={12}>
                  {/* Status Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Status"
                    name="status"
                    value={filterInputs.status}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {statusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item md={3} xs={12}>
                  {/* Approval Status Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Approval Status"
                    name="approvalStatus"
                    value={filterInputs.approvalStatus}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {approvalStatusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid container item md={6} xs={12} spacing={1}>
                  <Grid item md={6} xs={12}>
                    <Autocomplete
                      options={countryList || []}
                      getOptionLabel={(country) => country.CountryName || ''}
                      disabled
                      renderOption={(props, country) => (
                        <li {...props} key={country.CountryId}>
                          {country.CountryName}
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                      value={filterInputs.senderCountry || null}
                      name="senderCountry"
                      onChange={(event, value) => {
                        setFilterInputs({ ...filterInputs, senderCountry: value });
                      }}
                      size="small"
                      renderInput={(params) => <TextField {...params} label="Sender Country" />}
                    />
                  </Grid>

                  <Grid item md={6} xs={12}>
                    <Autocomplete
                      options={countryList || []}
                      getOptionLabel={(country) => country.CountryName || ''}
                      renderOption={(props, country) => (
                        <li {...props} key={country.CountryId}>
                          {country.CountryName}
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                      value={filterInputs.receiverCountry || null}
                      name="receiverCountry"
                      onChange={(event, value) => {
                        setFilterInputs({ ...filterInputs, receiverCountry: value });
                      }}
                      size="small"
                      renderInput={(params) => <TextField {...params} label="Receiver Country" />}
                    />
                  </Grid>
                </Grid>
                <Grid item md={3} xs={12}>
                  <Autocomplete
                    options={salesExecutiveFilterData}
                    getOptionLabel={(salesPerson) => salesPerson.salesPersonName}
                    renderOption={(props, salesPerson) => (
                      <li {...props} key={salesPerson.salesPersonId}>
                        {salesPerson.salesPersonName}
                      </li>
                    )}
                    isOptionEqualToValue={(salesPerson) =>
                      salesPerson.salesPersonId === filterInputs.salesExecutive.salesPersonId
                    }
                    value={filterInputs.salesExecutive || null}
                    name="Sales Executive"
                    onChange={(event, value) => {
                      setFilterInputs({ ...filterInputs, salesExecutive: value });
                    }}
                    size="small"
                    renderInput={(params) => <TextField {...params} label="Sales Executive" />}
                  />
                </Grid>
                <Grid item md={3} xs={12}>
                  {/* Complaint Status item Filter */}
                  <TextField
                    fullWidth
                    select
                    label="Complaint Status"
                    name="complaintStatus"
                    value={filterInputs.complaintStatus}
                    onChange={handleFilterInputs}
                    variant="outlined"
                    size="small"
                  >
                    {complaintStatusOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
                  <Grid item md={2} xs={6} sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {/* Draft Mode Switch */}
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        bgcolor: viewDraft ? '#eff6ff' : '#f8fafc',
                        borderRadius: '8px',
                        px: 0.75,
                        py: 0.75,
                        border: `1px solid ${viewDraft ? '#3b82f6' : '#e2e8f0'}`,
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          borderColor: viewDraft ? '#2563eb' : '#cbd5e1',
                          boxShadow: viewDraft
                            ? '0 0 0 2px rgba(59, 130, 246, 0.1)'
                            : '0 0 0 2px rgba(203, 213, 225, 0.1)',
                        },
                      }}
                    >
                      {/* Custom Switch - Compact */}
                      <Box
                        onClick={() => {
                          setViewDraft(!viewDraft);
                          setTableData([]);
                        }}
                        sx={{
                          position: 'relative',
                          width: 42,
                          height: 24,
                          borderRadius: '12px',
                          bgcolor: viewDraft ? '#3b82f6' : '#94a3b8',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          overflow: 'hidden',
                          flexShrink: 0,
                          '&:before': {
                            content: '""',
                            position: 'absolute',
                            top: 2,
                            left: viewDraft ? 20 : 2,
                            width: 20,
                            height: 20,
                            borderRadius: '50%',
                            bgcolor: 'white',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
                          },
                          '&:after': {
                            content: '""',
                            position: 'absolute',
                            top: '50%',
                            left: viewDraft ? 6 : 24,
                            transform: 'translateY(-50%)',
                            width: 8,
                            height: 8,
                            backgroundImage: viewDraft
                              ? 'radial-gradient(circle, #60a5fa 1px, transparent 1px)'
                              : 'radial-gradient(circle, #cbd5e1 1px, transparent 1px)',
                            backgroundSize: '3px 3px',
                            opacity: 0.5,
                            transition: 'all 0.2s ease',
                          },
                        }}
                      />

                      {/* Label with Icon - Compact */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 80 }}>
                        <Box
                          sx={{
                            width: 22,
                            height: 22,
                            borderRadius: '5px',
                            bgcolor: viewDraft ? '#dbeafe' : '#f1f5f9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: `1px solid ${viewDraft ? '#bfdbfe' : '#e2e8f0'}`,
                          }}
                        >
                          {viewDraft ? (
                            <span style={{ fontSize: 13, color: '#3b82f6' }}>📝</span>
                          ) : (
                            // <LocalShippingIcon sx={{ fontSize: 13, color: '#3b82f6' }} />
                            <span style={{ fontSize: 13, color: '#64748b' }}>📝</span>
                            // <LocalShippingIcon sx={{ fontSize: 13, color: '#64748b' }} />
                          )}
                        </Box>
                        <Box>
                          <Typography variant="body2" fontWeight="500" color={viewDraft ? '#1e40af' : '#475569'}>
                            {viewDraft ? 'Draft' : 'Draft'}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={1}>
                    {/* View Button */}
                    <Button variant="contained" color="primary" onClick={getAllData} fullWidth sx={{ boxShadow: 0 }}>
                      View
                    </Button>
                  </Grid>
                  {sessionStorage.getItem('userRole') !== 'Sales' && (
                    <Grid item xs={6} md={1}>
                      <Button
                        variant="contained"
                        style={{ color: 'white', backgroundColor: '#118a27' }}
                        onClick={GetOrderFollowupExcel}
                        fullWidth
                      >
                        Excel
                      </Button>
                    </Grid>
                  )}
                  <Grid item md={2} xs={12}>
                    <Button
                      variant="contained"
                      // color="primary"
                      fullWidth
                      endIcon={<LocalShippingIcon style={{ color: 'white' }} />}
                      sx={{
                        whiteSpace: 'nowrap',
                        boxShadow: '0',
                        position: 'relative',
                        zIndex: 1,
                        overflow: 'hidden',
                        bgcolor: '#003161',
                      }}
                      onClick={handleAddButtonClick}
                      className="booking_button_newSEBooking"
                    >
                      New Booking
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
        <Collapse in={tableData.length > 0}>
          <Stack>
            <Grid container spacing={2} mb={2}>
              {dataList.map((item, index) => (
                <Grid item xs={index === 4 ? 12 : 6} sm={index === 4 ? 12 : 4} md={2.4} key={index}>
                  <Paper elevation={6} sx={{ bgcolor: item.bgColor, p: 1, flexGrow: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: item.textColor }} textAlign="center">
                      {item.title}
                    </Typography>
                    <Typography variant="h5" sx={{ color: item.textColor }} textAlign="center">
                      {item.value}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Stack>
        </Collapse>
        <Collapse in={tableData.length > 0}>
          <>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    <StyledTableCell align="left">Order No</StyledTableCell>
                    <StyledTableCell align="left">Order Date</StyledTableCell>
                    <StyledTableCell align="left">Ledger Details</StyledTableCell>
                    <StyledTableCell align="center">Branch</StyledTableCell>
                    <StyledTableCell align="center">Primary SE</StyledTableCell>
                    <StyledTableCell align="center">Secondary SE</StyledTableCell>
                    <StyledTableCell align="center">Shipment Type</StyledTableCell>
                    <StyledTableCell align="center">Sender Country</StyledTableCell>
                    <StyledTableCell align="center">Receiver Counry</StyledTableCell>
                    <StyledTableCell align="center">Parcel Weight</StyledTableCell>
                    <StyledTableCell align="center">No of Boxes</StyledTableCell>
                    <StyledTableCell align="center">Approval Status</StyledTableCell>
                    <StyledTableCell align="center">Order Status</StyledTableCell>
                    <StyledTableCell align="center">Bill Status</StyledTableCell>
                    <StyledTableCell align="center">Receipt Status</StyledTableCell>
                    {/* <StyledTableCell align="center">Sales Executive</StyledTableCell> */}
                    <StyledTableCell align="center">Bill Amount</StyledTableCell>
                    <StyledTableCell align="center">Paid Amount</StyledTableCell>
                    <StyledTableCell align="center">Balance Amount</StyledTableCell>
                    <StyledTableCell align="center">Approved By</StyledTableCell>
                    <StyledTableCell align="center">Updated By</StyledTableCell>
                    <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2 }}>
                      Actions
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : tableData
                  ).map((data, i) => (
                    <>
                      <TableRow key={`${data.customerId}${data.orderNo}${data.orderId}`} hover>
                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                        <TableCell align="center">
                          {data.orderNo || '-'}
                          {data.IsDraft === 'Y' && (
                            <div
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '3px 7px',
                                borderRadius: '12px',
                                backgroundColor: '#e3f2fd',
                                border: '1px solid #90caf9',
                              }}
                            >
                              <span style={{ fontSize: '14px', color: '#1976d2' }}>📝</span>
                              <span
                                style={{
                                  color: '#1565c0',
                                  fontWeight: '600',
                                  fontSize: '0.75rem',
                                }}
                              >
                                Draft
                              </span>
                            </div>
                          )}
                        </TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          {moment(data.orderDate).format('DD/MM/YYYY') || '-'}
                        </TableCell>

                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack spacing={1} py={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <PortraitIcon fontSize="x-small" color="primary" />
                              <Typography variant="body2" pr={1}>
                                {data.customerName || '-'}
                              </Typography>{' '}
                              {data.hasNewItem === 'Y' && (
                                <Chip
                                  label="new goods"
                                  size="small"
                                  variant="outlined"
                                  color="success"
                                  sx={{
                                    boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89',
                                    animation: 'glow 1.5s infinite',
                                    '@keyframes glow': {
                                      '0%': { boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89' },
                                      '50%': { boxShadow: '0 0 4px #EBEAFF, 0 0 6px #EBEAFF' },
                                      '100%': { boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89' },
                                    },
                                  }}
                                />
                              )}
                              {Number(data.SalesPersonId) === Number(sessionStorage.getItem('UserId')) &&
                                data.approvalStatus === 'Y' &&
                                data.isFromSales === 'Y' &&
                                Number(data.created_By) !== Number(sessionStorage.getItem('UserId')) && (
                                  <Chip
                                    label="Cross booked"
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    sx={{
                                      // backgroundColor: '#5765e8',
                                      color: '#5765e8',
                                      fontWeight: 600,
                                    }}
                                  />
                                )}
                              {Number(data.complaintId) !== 0 && (
                                <Chip
                                  label="complaints received"
                                  size="small"
                                  variant="outlined"
                                  color="warning"
                                  sx={{
                                    boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89',
                                    animation: 'glow 1.5s infinite',
                                    transition: 'transform 0.3s ease', // smooth zoom transition
                                    '@keyframes glow': {
                                      '0%': { boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89' },
                                      '50%': { boxShadow: '0 0 4px #EBEAFF, 0 0 6px #EBEAFF' },
                                      '100%': { boxShadow: '0 0 4px #A8CD89, 0 0 4px #A8CD89' },
                                    },
                                    '&:hover': {
                                      transform: 'scale(1.05)', // slight zoom
                                    },
                                  }}
                                />
                              )}
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Phone fontSize="x-small" color="success" />
                              <Typography variant="body2" mr={2} pr={1}>
                                {data.phone || '-'}
                              </Typography>{' '}
                              | <Email fontSize="x-small" color="error" />
                              <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                                {data.emailId || '-'}
                              </Typography>
                            </Stack>{' '}
                          </Stack>
                        </TableCell>
                        <TableCell align="center">{data.Branch_Name || '-'}</TableCell>
                        <TableCell align="center">{data.PrimarySEName || '-'}</TableCell>
                        <TableCell align="center">{data.SecondarySEName || '-'}</TableCell>
                        <TableCell align="center">
                          {(data.shipmentType === 'Courier' ? 'Air-Cargo' : 'Sea-Cargo') || '-'}
                        </TableCell>
                        <TableCell align="center">{data.SenderCountryName || '-'}</TableCell>
                        <TableCell align="center">{data.ReceiverCountryName || '-'}</TableCell>
                        <TableCell align="center">{data.gross_weight || '-'}</TableCell>
                        <TableCell align="center">{data.NO_OF_BOXES || '-'}</TableCell>
                        {/* <TableCell align="center">
                          {data.isCancel === 'Y' ? (
                            <Chip label="Cancelled" size="small" color="error" />
                          ) : data.OrderRaised === 'Y' ? (
                            <Chip label="Booking Confirmed" size="small" color="info" />
                          ) : data.approvalStatus === 'Y' ? (
                            <Chip label="Approved" size="small" color="success" />
                          ) : data.SE_OrderCancelReq === 'R' ? (
                            <Chip label="Cancel Requested" size="small" variant="outlined" color="error" />
                          ) : (
                            <Chip label="Pending" size="small" color="warning" />
                          )}
                        </TableCell> */}
                        <TableCell align="center">
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                            {data.singleOrderStatus === 'Cancelled' ? (
                              <Chip label={data.singleOrderStatus} size="small" color="error" />
                            ) : data.singleOrderStatus === 'Bill Raised' ||
                              data.singleOrderStatus === 'Payment Received' ||
                              data.singleOrderStatus === 'Booking Confirmed' ||
                              data.singleOrderStatus === 'Part Payment' ? (
                              <Chip label={data.singleOrderStatus} size="small" color="info" />
                            ) : data.singleOrderStatus === 'Approved' ? (
                              <Chip label={data.singleOrderStatus} size="small" color="success" />
                            ) : data.singleOrderStatus === 'Cancel Requested' ? (
                              <Chip label={data.singleOrderStatus} size="small" variant="outlined" color="error" />
                            ) : (
                              <Chip label={data.singleOrderStatus} size="small" color="warning" />
                            )}
                            {data.TrackNo && (
                              <Button
                                variant="outlined"
                                size="small"
                                className="track_button"
                                startIcon={<LocalShippingIcon />}
                                onClick={() => {
                                  window.open(
                                    `${axios.defaults.TRACKING_URL}${sessionStorage.getItem('country')}/${
                                      data.TrackNo
                                    }`,
                                    '_blank'
                                  );
                                }}
                                sx={{
                                  '& .MuiButton-startIcon': {
                                    animation: 'moveTruck 2s ease-in-out infinite',
                                    '@keyframes moveTruck': {
                                      '0%, 100%': {
                                        transform: 'translateX(0)',
                                      },
                                      '50%': {
                                        transform: 'translateX(5px)',
                                      },
                                    },
                                  },
                                  '&:hover': {
                                    '& .MuiButton-startIcon': {
                                      animation: 'bounce 0.5s ease infinite',
                                      '@keyframes bounce': {
                                        '0%, 100%': {
                                          transform: 'translateY(0)',
                                        },
                                        '50%': {
                                          transform: 'translateY(-2px)',
                                        },
                                      },
                                    },
                                  },
                                }}
                              >
                                Track
                              </Button>
                            )}
                          </div>
                        </TableCell>

                        <TableCell align="center">
                          {data.OrderStatus === 'Yes' ? (
                            <Chip label="Yes" size="small" color="success" />
                          ) : (
                            <Chip label="No" size="small" color="warning" />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {data.BillStatus === 'Yes' ? (
                            <Chip label="Yes" size="small" color="success" />
                          ) : (
                            <Chip label="No" size="small" color="warning" />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {data.ReceiptStatus === 'Yes' ? (
                            <Chip label="Yes" size="small" color="success" />
                          ) : (
                            <Chip label="No" size="small" color="warning" />
                          )}
                        </TableCell>

                        {/* <TableCell align="center">{data.salesExecutives || '-'}</TableCell> */}
                        <TableCell align="center">
                          {numeral(data.BillAmt).format('0,0.00') || numeral(0).format('0,0.00')}
                        </TableCell>
                        <TableCell align="center">
                          {numeral(data.PaidAmount).format('0,0.00') || numeral(0).format('0,0.00')}
                        </TableCell>
                        <TableCell align="center">
                          {numeral(data.BalAmt).format('0,0.00') || numeral(0).format('0,0.00')}
                        </TableCell>
                        <TableCell align="center">{data.ApprovedByName || '-'}</TableCell>
                        <TableCell align="center">{data.UpdatedByName || '-'}</TableCell>

                        <TableCell
                          align="center"
                          sx={{
                            position: { xs: 'static', md: 'sticky' },
                            right: { xs: 0, md: 0 },
                            bgcolor: { xs: 'inherit', md: '#F9FAFB' },
                            zIndex: { xs: 'auto', md: 1 },
                            backdropFilter: 'blur(20px)',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <Stack direction="column" spacing={1} justifyContent="center" alignItems="center" my={1}>
                            {
                              // moment(data?.ExpiryDate).format('YYYYMMDD') === '19000101' &&
                              (Number(data.SecondarySEId) === Number(sessionStorage.getItem('UserId')) ||
                                Number(data.SecondarySEId) === 0) && (
                                <Button
                                  variant={
                                    data.IsDraft === 'Y'
                                      ? 'contained'
                                      : data.approvalStatus === 'N' && data.isCancel === 'N'
                                      ? data.SE_OrderCancelReq === 'R'
                                        ? 'contained'
                                        : 'contained'
                                      : 'outlined'
                                  }
                                  color={
                                    data.IsDraft === 'Y'
                                      ? 'info'
                                      : data.approvalStatus === 'N' && data.isCancel === 'N'
                                      ? data.SE_OrderCancelReq === 'R'
                                        ? 'warning'
                                        : 'success'
                                      : 'info'
                                  }
                                  sx={{ boxShadow: 1 }}
                                  onClick={() => handleReviewButtonClick(data)}
                                  size="small"
                                  fullWidth
                                  startIcon={
                                    data.IsDraft === 'Y' ? (
                                      <EditNoteIcon fontSize="small" />
                                    ) : data.approvalStatus === 'N' && data.isCancel === 'N' ? (
                                      data.SE_OrderCancelReq === 'R' ? (
                                        <PreviewIcon fontSize="small" />
                                      ) : (
                                        <VerifiedIcon fontSize="small" />
                                      )
                                    ) : (
                                      <PreviewIcon fontSize="small" />
                                    )
                                  }
                                >
                                  {data.IsDraft === 'Y'
                                    ? 'Continue'
                                    : (data.hasNewItem === 'Y' && data.Status === 'Y' && data.approvalStatus === 'N') ||
                                      data.OrderRaised === 'Y'
                                    ? 'View'
                                    : data.approvalStatus === 'N' && data.isCancel === 'N'
                                    ? data.SE_OrderCancelReq === 'R'
                                      ? 'Review'
                                      : 'Approve'
                                    : 'View'}
                                </Button>
                              )
                            }
                            {data.NewItemStatus === 'Y' && (
                              <Button
                                variant="contained"
                                color="primary"
                                sx={{ boxShadow: 1, whiteSpace: 'nowrap' }} // Corrected whiteSpace
                                onClick={() => handleFollowUpTableToggle(i, data)}
                                size="small"
                                fullWidth
                                startIcon={<EventRepeatIcon fontSize="small" />}
                              >
                                Follow-ups
                              </Button>
                            )}
                            {Number(data.ManifestId) !== 0 && (
                              <Button
                                variant="outlined"
                                color="error"
                                sx={{ boxShadow: 1, whiteSpace: 'nowrap' }}
                                onClick={() => {
                                  openComplaintDialog(data);
                                }}
                                size="small"
                                fullWidth
                                startIcon={<ReportGmailerrorredIcon fontSize="small" />}
                              >
                                {Number(data.complaintId) === 0 ? 'Register Complaint' : 'View Complaint'}
                              </Button>
                            )}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              mt={2}
            />
          </>
        </Collapse>
        {tableData.length === 0 && <NoResultsFound />}

        {/* Dialog to display review content */}
        <Dialog fullScreen open={isDialogOpen} onClose={closeDialog}>
          <DialogTitle>
            <Typography
              variant="h5"
              p={1}
              boxShadow={1}
              borderColor="#11235A"
              textAlign={'center'}
              borderRadius={8}
              color="white"
              sx={{
                background:
                  currentOrderDetails?.shipmentType === 'Courier'
                    ? 'linear-gradient(to right, #667db6, #0082c8, #0082c8, #667db6)'
                    : 'linear-gradient(to right, #4ecdc4, #556270)',
                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
              }}
            >
              <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                {currentOrderDetails?.shipmentType} - Order Preview for Order No {currentOrderDetails?.orderNo}
              </Typography>
            </Typography>
          </DialogTitle>
          <DialogContent>
            {currentOrderDetails &&
              (currentOrderDetails?.shipmentType === 'Courier' ? (
                <PreviewForCourierOrderApproval
                  setDialogOpenState={setDialogOpenState}
                  orderDetails={currentOrderDetails}
                  getAllData={getAllData}
                />
              ) : (
                <PreviewForCargoOrderApproval
                  setDialogOpenState={setDialogOpenState}
                  orderDetails={currentOrderDetails}
                  getAllData={getAllData}
                />
              ))}
          </DialogContent>
        </Dialog>

        {/* Dialog to Add content */}
        <Dialog fullScreen open={isAddDialogOpen} onClose={closeAddDialog}>
          <DialogTitle>
            <Typography
              variant="h5"
              p={1}
              boxShadow={1}
              borderColor="#11235A"
              textAlign={'center'}
              borderRadius={8}
              color="white"
              sx={{
                background: ' linear-gradient(to right, #000428, #004e92)',
                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
              }}
            >
              <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                Order Creation
              </Typography>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <AddBookingForCourierAndCargoOrderCreation
              setAddDialogOpenState={setAddDialogOpenState}
              getAllData={getAllData}
              ledgerPhoneFilterData={ledgerPhoneFilterData}
            />
          </DialogContent>
        </Dialog>

        {/* Dialog for Adding New Follow-up */}
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>{isEditing ? 'Edit Follow-up' : 'Add Follow-up'}</DialogTitle>
          <DialogContent>
            <Stack sx={{ width: '100%' }} mt={2} fullWidth>
              {/* Follow-up Date and Time Input */}
              <TextField
                size="small"
                fullWidth
                label="Follow-up Date and Time"
                type="datetime-local"
                value={newFollowUp.followUpDateTime}
                onChange={handleFollowUpDateTimeChange}
                error={fieldErrors.followUpDateTime}
                helperText={fieldErrors.followUpDateTime ? 'Follow-up date and time must be in the future' : ''}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              {/* Remarks Input */}
              <TextField
                label="Remarks"
                name="remarks"
                fullWidth
                margin="dense"
                multiline
                rows={3}
                value={newFollowUp.remarks}
                onChange={handleFollowUpChange}
                inputProps={{ maxLength: 100 }}
              />
            </Stack>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions>
            <Button onClick={handleCloseDialog} color="warning" variant="contained" size="small">
              Cancel
            </Button>
            <Button
              onClick={InsertCustomerTimeLine}
              color={isEditing ? 'primary' : 'success'}
              variant="contained"
              size="small"
              disabled={!newFollowUp.followUpDateTime || !newFollowUp.remarks.trim() || fieldErrors.followUpDateTime}
            >
              {isEditing ? 'Save' : 'Add'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog for follow-up table */}
        <Dialog open={openFollowUpTable} maxWidth={'xl'} fullScreen={smallScreens} fullWidth>
          <DialogContent>
            <Divider sx={{ mt: 2 }}>
              <Chip
                label={`Follow-Ups on ${rowData?.shipmentType} : Order No.  ${rowData?.orderNo}`}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Divider>
            <Grid container spacing={2} mb={1}>
              {!smallScreens && (
                <Grid item md={9} xs={12}>
                  <Stack spacing={1}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <PortraitIcon fontSize="x-small" color="primary" />
                      <Typography variant="subtitle2" color="#243642" pr={1}>
                        {rowData?.customerName || '-'}{' '}
                      </Typography>{' '}
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Phone fontSize="x-small" color="success" />
                      <Typography variant="body2" mr={2} pr={1}>
                        {rowData?.phone || '-'}
                      </Typography>{' '}
                      | <Email fontSize="x-small" color="error" />
                      <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                        {rowData?.emailId || '-'}
                      </Typography>
                    </Stack>{' '}
                  </Stack>
                </Grid>
              )}
              <Grid item md={3} xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                  {rowData?.canFollowUp === 'Y' && rowData?.SalesPersonId === sessionStorage.getItem('UserId') && (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => handleOpenDialog(rowData?.CUSTOMERID)}
                      size="small"
                    >
                      Add Follow-up
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell2 align="center">S.No</StyledTableCell2>
                    <StyledTableCell2 align="center">Follow-up Date & Time </StyledTableCell2>
                    <StyledTableCell2 align="left">Remarks</StyledTableCell2>
                    <StyledTableCell2 align="center">Created Date & Time </StyledTableCell2>
                    <StyledTableCell2 align="center">Created By</StyledTableCell2>
                    {/* {moment(rowData?.ExpiryDate).format('YYYYMMDD') === '19000101' &&
                      <StyledTableCell2 align="center">Actions</StyledTableCell2>
                    } */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {oneCustomerFollowUps.map((followUp, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {moment.utc(followUp.followupDate).format('LLL')}
                      </TableCell>
                      {/* <TableCell align="left">{followUp.followup !== 'Follow Up' ? <Chip label={'Cancel Remarks'} size="small" color="error" />followUp.remarks : followUp.remarks}</TableCell> */}
                      <TableCell align="left">
                        {followUp.followup !== 'Follow Up' ? (
                          <>
                            <Chip label={'Cancel Remarks :'} size="small" color="error" sx={{ mr: 1 }} />
                            {followUp.remarks}
                          </>
                        ) : (
                          followUp.remarks
                        )}
                      </TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {moment(followUp.createdOn).format('LLL')}
                      </TableCell>
                      <TableCell align="center">{followUp.CreatedUser}</TableCell>
                      {/* {moment(rowData?.ExpiryDate).format('YYYYMMDD') === '19000101' &&
                        <TableCell align="center" sx={{ padding: '0' }}>
                          <IconButton aria-label="Edit" onClick={() => handleEditFollowUp(followUp)}>
                            <EditIcon color="primary" />
                          </IconButton>
                          <IconButton aria-label="Delete" onClick={() => handleOpenConfirmDialog(followUp.timelineId)}>
                            <DeleteForeverIcon color="error" />
                          </IconButton>
                        </TableCell>
                      } */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mt={2}>
              <Button
                onClick={() => {
                  setOpenFollowUpTable(null);
                  SetRowData(null);
                }}
                color="warning"
                variant="contained"
                size="small"
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>

        {/* Confirmation Dialog for Deletion */}
        <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this Record?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseConfirmDialog} color="warning" variant="contained" size="small">
              Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="error" variant="contained" size="small">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add Complaint Popup */}
        <Dialog fullWidth maxWidth={'md'} open={isComplaintDialogOpen} onClose={closeComplaintDialog}>
          <DialogContent>
            <ComplaintAdd
              setComplaintDialogOpenState={setComplaintDialogOpenState}
              complaintDetail={complaintDetail}
              getAllData={getAllData}
            />
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default OrderFollwUps;
